import db from "../../firebase";
import { doc, updateDoc } from "firebase/firestore";

import { useSelector, useDispatch } from "react-redux";
import { updateAdminSuccessMsg } from "../../store/actions";

import { Modal, TextField, Button, Box, Typography } from "@mui/material";
import DateAdapter from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DateTimePicker from "@mui/lab/DateTimePicker";

const ModalCard = ({
  activeAdminCelebModal,
  setActiveAdminCelebModal,
  editActiveCelebImageData,
  setEditActiveCelebImageData,
}) => {
  const dispatch = useDispatch();
  const adminActiveCelebList = useSelector(
    (state) => state.adminActiveCelebList
  );

  const updateFn = () => {
    if (!Number.isInteger(editActiveCelebImageData.highestBid)) {
      return;
    }

    if (editActiveCelebImageData.timeLeft < new Date()) {
      alert("End Time should be greater than current time");
      return;
    }

    if (
      editActiveCelebImageData.timeLeft < editActiveCelebImageData.startTime
    ) {
      alert("End time should be greater than start time");
      return;
    }

    const aboutLinksTemp = {
      instagram: editActiveCelebImageData.about_links_instagram,
      trans: editActiveCelebImageData.about_links_trans,
      web: editActiveCelebImageData.about_links_web,
    };

    const propertiesTemp = [
      editActiveCelebImageData.properties1,
      editActiveCelebImageData.properties2,
      editActiveCelebImageData.properties3,
    ];

    const detailsTemp = {
      about: editActiveCelebImageData.about,
      about_description: editActiveCelebImageData.about_description,
      blockchain: editActiveCelebImageData.blockchain,
      contract_address: editActiveCelebImageData.contract_address,
      created_by: editActiveCelebImageData.created_by,
      created_on: editActiveCelebImageData.created_on,
      metadata: editActiveCelebImageData.metadata,
      title: editActiveCelebImageData.title,
      token_id: editActiveCelebImageData.token_id,
      token_standard: editActiveCelebImageData.token_standard,
      views: editActiveCelebImageData.views,
      about_links: aboutLinksTemp,
      properties: propertiesTemp,
    };

    updateDoc(
      doc(db, `biddify/${adminActiveCelebList}/gallery`, activeAdminCelebModal),
      {
        highestBid: editActiveCelebImageData.highestBid,
        timeLeft: editActiveCelebImageData.timeLeft,
        startTime: editActiveCelebImageData.startTime,
        details: detailsTemp,
      }
    );

    setActiveAdminCelebModal(false);
    dispatch(updateAdminSuccessMsg("Details updated!"));
    setTimeout(() => dispatch(updateAdminSuccessMsg("")), 1000);
  };

  return (
    <LocalizationProvider dateAdapter={DateAdapter}>
      <Modal
        open={activeAdminCelebModal === false ? false : true}
        onClose={() => setActiveAdminCelebModal(false)}
      >
        <Box
          sx={{
            position: "absolute",
            top: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            width: "90%",
            height: "auto",
            maxWidth: "800px",
            maxHeight: "95vh",
            bgcolor: "#fff",
            boxShadow: 24,
            p: 1,
            borderRadius: "4px",
            overflow: "auto",
          }}
        >
          <Typography
            sx={{ textAlign: "center", margin: "10px 0" }}
            variant="h5"
          >
            Edit Details
          </Typography>
          <DateTimePicker
            label="Start Time"
            name="startTime"
            value={
              editActiveCelebImageData && editActiveCelebImageData.startTime
            }
            onChange={(value) => {
              setEditActiveCelebImageData({
                ...editActiveCelebImageData,
                startTime: value,
              });
            }}
            renderInput={(params) => (
              <TextField
                sx={{ width: "48%", margin: "10px 1% 0" }}
                {...params}
              />
            )}
          />
          <DateTimePicker
            label="End Time"
            name="timeLeft"
            value={
              editActiveCelebImageData && editActiveCelebImageData.timeLeft
            }
            onChange={(value) => {
              setEditActiveCelebImageData({
                ...editActiveCelebImageData,
                timeLeft: value,
              });
            }}
            renderInput={(params) => (
              <TextField
                sx={{ width: "48%", margin: "10px 1% 0" }}
                {...params}
              />
            )}
          />
          <TextField
            label="Highest Bid"
            name="highestBid"
            variant="outlined"
            defaultValue={
              editActiveCelebImageData && editActiveCelebImageData.highestBid
            }
            onChange={(e) =>
              setEditActiveCelebImageData({
                ...editActiveCelebImageData,
                [e.target.name]: parseInt(e.target.value),
              })
            }
            sx={{ width: "48%", margin: "10px 1% 0" }}
          />
          <TextField
            label="About"
            name="about"
            variant="outlined"
            defaultValue={
              editActiveCelebImageData && editActiveCelebImageData.about
            }
            onChange={(e) =>
              setEditActiveCelebImageData({
                ...editActiveCelebImageData,
                [e.target.name]: e.target.value,
              })
            }
            sx={{ width: "48%", margin: "10px 1% 0" }}
          />
          <TextField
            label="About Description"
            name="about_description"
            variant="outlined"
            defaultValue={
              editActiveCelebImageData &&
              editActiveCelebImageData.about_description
            }
            onChange={(e) =>
              setEditActiveCelebImageData({
                ...editActiveCelebImageData,
                [e.target.name]: e.target.value,
              })
            }
            sx={{ width: "48%", margin: "10px 1% 0" }}
          />
          <TextField
            label="Blockchain"
            name="blockchain"
            variant="outlined"
            defaultValue={
              editActiveCelebImageData && editActiveCelebImageData.blockchain
            }
            onChange={(e) =>
              setEditActiveCelebImageData({
                ...editActiveCelebImageData,
                [e.target.name]: e.target.value,
              })
            }
            sx={{ width: "48%", margin: "10px 1% 0" }}
          />
          <TextField
            label="Contract Address"
            name="contract_address"
            variant="outlined"
            defaultValue={
              editActiveCelebImageData &&
              editActiveCelebImageData.contract_address
            }
            onChange={(e) =>
              setEditActiveCelebImageData({
                ...editActiveCelebImageData,
                [e.target.name]: e.target.value,
              })
            }
            sx={{ width: "48%", margin: "10px 1% 0" }}
          />
          <TextField
            label="Created By"
            name="created_by"
            variant="outlined"
            defaultValue={
              editActiveCelebImageData && editActiveCelebImageData.created_by
            }
            onChange={(e) =>
              setEditActiveCelebImageData({
                ...editActiveCelebImageData,
                [e.target.name]: e.target.value,
              })
            }
            sx={{ width: "48%", margin: "10px 1% 0" }}
          />

          <DateTimePicker
            label="Created On"
            name="created_on"
            value={
              editActiveCelebImageData && editActiveCelebImageData.created_on
            }
            onChange={(value) => {
              setEditActiveCelebImageData({
                ...editActiveCelebImageData,
                created_on: value,
              });
            }}
            renderInput={(params) => (
              <TextField
                sx={{ width: "48%", margin: "10px 1% 0" }}
                {...params}
              />
            )}
          />
          <TextField
            label="Metadata"
            name="metadata"
            variant="outlined"
            defaultValue={
              editActiveCelebImageData && editActiveCelebImageData.metadata
            }
            onChange={(e) =>
              setEditActiveCelebImageData({
                ...editActiveCelebImageData,
                [e.target.name]: e.target.value,
              })
            }
            sx={{ width: "48%", margin: "10px 1% 0" }}
          />
          <TextField
            label="Title"
            name="title"
            variant="outlined"
            defaultValue={
              editActiveCelebImageData && editActiveCelebImageData.title
            }
            onChange={(e) =>
              setEditActiveCelebImageData({
                ...editActiveCelebImageData,
                [e.target.name]: e.target.value,
              })
            }
            sx={{ width: "48%", margin: "10px 1% 0" }}
          />
          <TextField
            label="Token Id"
            name="token_id"
            variant="outlined"
            defaultValue={
              editActiveCelebImageData && editActiveCelebImageData.token_id
            }
            onChange={(e) =>
              setEditActiveCelebImageData({
                ...editActiveCelebImageData,
                [e.target.name]: e.target.value,
              })
            }
            sx={{ width: "48%", margin: "10px 1% 0" }}
          />
          <TextField
            label="Token Standard"
            name="token_standard"
            variant="outlined"
            defaultValue={
              editActiveCelebImageData &&
              editActiveCelebImageData.token_standard
            }
            onChange={(e) =>
              setEditActiveCelebImageData({
                ...editActiveCelebImageData,
                [e.target.name]: e.target.value,
              })
            }
            sx={{ width: "48%", margin: "10px 1% 0" }}
          />
          <TextField
            label="Views"
            name="views"
            variant="outlined"
            defaultValue={
              editActiveCelebImageData && editActiveCelebImageData.views
            }
            onChange={(e) =>
              setEditActiveCelebImageData({
                ...editActiveCelebImageData,
                [e.target.name]: e.target.value,
              })
            }
            sx={{ width: "48%", margin: "10px 1% 0" }}
          />
          <Typography
            sx={{ width: "98%", margin: "15px 1% 5px", fontSize: "15px" }}
            variant="h5"
          >
            About Links
          </Typography>
          <TextField
            label="Instagram"
            name="about_links_instagram"
            variant="outlined"
            defaultValue={
              editActiveCelebImageData &&
              editActiveCelebImageData.about_links_instagram
            }
            onChange={(e) =>
              setEditActiveCelebImageData({
                ...editActiveCelebImageData,
                [e.target.name]: e.target.value,
              })
            }
            sx={{ width: "48%", margin: "10px 1% 0" }}
          />
          <TextField
            label="Trans"
            name="about_links_trans"
            variant="outlined"
            defaultValue={
              editActiveCelebImageData &&
              editActiveCelebImageData.about_links_trans
            }
            onChange={(e) =>
              setEditActiveCelebImageData({
                ...editActiveCelebImageData,
                [e.target.name]: e.target.value,
              })
            }
            sx={{ width: "48%", margin: "10px 1% 0" }}
          />
          <TextField
            label="Web"
            name="about_links_web"
            variant="outlined"
            defaultValue={
              editActiveCelebImageData &&
              editActiveCelebImageData.about_links_web
            }
            onChange={(e) =>
              setEditActiveCelebImageData({
                ...editActiveCelebImageData,
                [e.target.name]: e.target.value,
              })
            }
            sx={{ width: "48%", margin: "10px 1% 0" }}
          />
          <Typography
            sx={{ width: "98%", margin: "15px 1% 5px", fontSize: "15px" }}
            variant="h5"
          >
            Properties
          </Typography>
          <TextField
            label="Properties 1"
            name="properties1"
            variant="outlined"
            defaultValue={
              editActiveCelebImageData && editActiveCelebImageData.properties1
            }
            onChange={(e) =>
              setEditActiveCelebImageData({
                ...editActiveCelebImageData,
                [e.target.name]: e.target.value,
              })
            }
            sx={{ width: "48%", margin: "10px 1% 0" }}
          />
          <TextField
            label="Properties 2"
            name="properties2"
            variant="outlined"
            defaultValue={
              editActiveCelebImageData && editActiveCelebImageData.properties2
            }
            onChange={(e) =>
              setEditActiveCelebImageData({
                ...editActiveCelebImageData,
                [e.target.name]: e.target.value,
              })
            }
            sx={{ width: "48%", margin: "10px 1% 0" }}
          />
          <TextField
            label="Properties 3"
            name="properties3"
            variant="outlined"
            defaultValue={
              editActiveCelebImageData && editActiveCelebImageData.properties3
            }
            onChange={(e) =>
              setEditActiveCelebImageData({
                ...editActiveCelebImageData,
                [e.target.name]: e.target.value,
              })
            }
            sx={{ width: "48%", margin: "10px 1% 0" }}
          />
          <Button
            variant="contained"
            sx={{
              width: "100%",
              margin: "5px 0",
              backgroundColor: "#ec004f",
              boxShadow: "none",
              "&:hover": { backgroundColor: "#ec004f", boxShadow: "none" },
            }}
            onClick={() => updateFn()}
          >
            Update
          </Button>
        </Box>
      </Modal>
    </LocalizationProvider>
  );
};

export default ModalCard;
